import React from 'react';
import PropTypes from 'prop-types';
import { BuyPath } from '../../models';

export const BuyPathContextDefault = {
    FLIGHTS: BuyPath.FLIGHTS_PAGE,
    TRAINS: BuyPath.HOME_RAIL_TAB,
    HOME_RAIL: BuyPath.HOME_RAIL,
    HSA_HOME: BuyPath.HSA_HOME,
    HSA_HOME_TAB: BuyPath.HSA_HOME_TAB,
    HSA_CRM: BuyPath.HSA_CRM,
    HSA_LANDING_WMP: BuyPath.HSA_LANDING_WMP,
};
export const BuyPathContext = React.createContext(BuyPathContextDefault);

export const BuyPathContextProp = PropTypes.object;

export const withBuyPathContext = (Child) => (props) =>
    (
        <BuyPathContext.Consumer>
            {(context) => <Child buyPaths={context} {...props} />}
        </BuyPathContext.Consumer>
    );
